import { Currency } from './billing.config'
import { useAccountDetailsQuery } from './queries'

export type BillingGateway = 'stripe' | 'cashfree' | 'razorpay'

// Single source of truth for which payment gateway an account uses in the
// console UI, so the modal switch, add-card gateway and pay mutation can't drift
// apart. USD → Stripe, INR → Razorpay. Razorpay is generally available, so INR no
// longer consults a flag and can no longer resolve to Cashfree; 'cashfree' stays
// in the union only until the dead provider branches are torn out. Returns
// 'stripe' until account details load, so we never open an INR gateway session
// for an account whose currency we don't yet know.
export const useBillingGateway = (): BillingGateway => {
  const { data: accountDetails } = useAccountDetailsQuery()

  if (!accountDetails) return 'stripe'
  return accountDetails.account?.currency === Currency.INR ? 'razorpay' : 'stripe'
}

// Always false now that every INR account resolves to Razorpay. Kept so the
// Cashfree-only call sites still compile; they are removed in the follow-up.
export const useIsCashfreeProvider = (): boolean => useBillingGateway() === 'cashfree'

// True when the account should see Razorpay flows — every INR account.
// Gates the recharge modal switch, saved-card picker, and add-card entry.
export const useIsRazorpayProvider = (): boolean => useBillingGateway() === 'razorpay'
